/**
 * AnnouncementTypeService
 * Service for managing announcement types
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for announcement type CRUD operations
 */
export class AnnouncementTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementTypeService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AnnouncementTypeService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementTypeService.BASE_PATH = 'api/announcement-types';
//# sourceMappingURL=AnnouncementTypeService.js.map